<template>
  <v-container class="pa-0 ma-0">
    <v-card class="config-card pa-0 ma-0 elevation-0">
      <v-card-title class="headline head-einvoice-config">
        <span class="text-h6 primary__blue py-1 ml-2">Datos de registro de factura</span>
        <v-spacer />
        <v-btn icon @click="$emit('cancel')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="config-body">
        <app-row class="table-row" dense>
            <app-col contains-input-fields cols="3">
                <v-text-field
                    class="primary-border roomy-input label-inside"
                    v-model="form.tipo"
                    label="Tipo"
                    outlined
                    hide-details="auto"
                    dense
                    readonly
                /> 
            </app-col>

            <app-col contains-input-fields cols="3">
                <v-text-field
                    class="primary-border roomy-input label-inside"
                    v-model="form.id"
                    label="Id"
                    outlined
                    hide-details="auto"
                    dense
                    readonly
                />
            </app-col>

            <app-col contains-input-fields cols="3">
                <v-text-field
                    class="primary-border roomy-input label-inside"
                    v-model="form.estado"
                    label="Estado"
                    outlined
                    hide-details="auto"
                    dense
                    readonly
                />
            </app-col>

            <app-col contains-input-fields cols="3">
                <v-text-field
                    class="primary-border roomy-input label-inside"
                    v-model="form.cif_emisor"
                    label="CIF del emisor"
                    outlined
                    hide-details="auto"
                    dense
                    readonly
                />
            </app-col>

            <app-col contains-input-fields cols="3">
                <v-text-field
                    class="primary-border roomy-input label-inside"
                    v-model="form.n_factura"
                    label="Número de factura"
                    outlined
                    hide-details="auto"
                    dense
                    readonly
                />
            </app-col>

            <app-col contains-input-fields cols="3">
                <v-text-field
                    class="primary-border roomy-input label-inside"
                    v-model="form.fecha_emision"
                    label="Fecha de emisión"
                    outlined
                    hide-details="auto"
                    dense
                    readonly
                />
            </app-col>

            <app-col contains-input-fields cols="3">
                <v-text-field
                    class="primary-border roomy-input label-inside"
                    v-model="form.cif_cliente"
                    label="CIF de cliente"
                    outlined
                    hide-details="auto"
                    dense
                    readonly
                />
            </app-col>

            <app-col contains-input-fields cols="3">
                <v-text-field
                    class="primary-border roomy-input label-inside"
                    v-model="form.nombre_cliente"
                    label="Nombre de cliente"
                    outlined
                    hide-details="auto"
                    dense
                    readonly
                />
            </app-col>
            <app-col contains-input-fields cols="3">
                <v-text-field
                    class="primary-border roomy-input label-inside"
                    v-model="form.total_base_imponible"
                    label="Total base imponible"
                    outlined
                    hide-details="auto"
                    dense
                    readonly
                />
            </app-col>
            <app-col contains-input-fields cols="3">
                <v-text-field
                    class="primary-border roomy-input label-inside"
                    v-model="form.total_impuestos"
                    label="Total impuestos"
                    outlined
                    hide-details="auto"
                    dense
                    readonly
                />
            </app-col>
            <app-col contains-input-fields cols="3">
                <v-text-field
                    class="primary-border roomy-input label-inside"
                    v-model="form.importe_total"
                    label="Importe total"
                    outlined
                    hide-details="auto"
                    dense
                    readonly
                />
            </app-col>
            <app-col contains-input-fields cols="12">
                <v-textarea
                    class="primary-border roomy-input label-inside"
                    v-model="form.error_verifactu"
                    label="Error verifactu"
                    outlined
                    hide-details="auto"
                    auto-grow
                    rows="1"
                    dense
                    readonly
                />
            </app-col>
            <app-col contains-input-fields cols="12">
                <v-textarea
                    class="primary-border roomy-input label-inside"
                    v-model="form.error_to_show"
                    label="Aclaración Error"
                    outlined
                    hide-details="auto"
                    auto-grow
                    rows="1"
                    dense
                    readonly
                />
            </app-col>
            <app-col contains-input-fields cols="12">
                <v-text-field
                    class="primary-border roomy-input label-inside"
                    v-model="form.cadena_bloques"
                    label="Cadena de bloques"
                    outlined
                    hide-details="auto"
                    dense
                    readonly
                />
            </app-col>
        </app-row>
      </v-card-text>
      <v-card-actions class="config-actions">
        <v-spacer />
        <v-btn outlined @click="$emit('cancel')" class="action__btn">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import AppRow from "@/components/layout/AppRow.vue";
import AppCol from "@/components/layout/AppCol.vue";

export default {
    name: "EInvoiceHistoryLogInfo",
    components: { AppRow, AppCol },
    props: { 
        invoiceableType: { type: String, default: "invoice" },
        record: { type: Object, default: null },
    },
    data() {
        return {
            form: {
                tipo: "",
                id: "",
                estado: "",
                cif_emisor: "",
                n_factura: "",
                fecha_emision: "",
                cif_cliente: "",
                nombre_cliente: "",
                total_base_imponible: "",
                total_impuestos: "",
                importe_total: "",
                error_to_show: "",
                error_verifactu: "",
                cadena_bloques: "",
            },
        };
    },
    computed: {
        nameToShow() {
            switch (this.invoiceableType) {
                case "invoice": return "Factura";
                case "delivery_note": return "Albarán";
                case "proforma": return "Proforma";
                case "ticket": return "F. Simplificada";
                default: return "Presupuesto";
            }
        },
    },
    watch: {
        record: {
            handler(newVal) {
                if (!newVal) return;
                    this.form = this.mapRecordToForm(newVal);
                },
            immediate: true,
        },
    },
    methods: {
        mapRecordToForm(r) {
            console.log('r =====> ', r)
            return {
                tipo:                   r.invoice_type || r.tipo || " ",
                id:                     (r.id != null ? String(r.id) : " "),
                estado:                 this.statusLabel(r.verifactu_status_code, r.verifactu_error_msj),
                cif_emisor:             r.issuer_nif || " ",
                n_factura:              r.invoice_series_number || " ",
                fecha_emision:          r.invoice_issue_date || " ",
                cif_cliente:            r.third_party_nif || " ",
                nombre_cliente:         r.third_party_name || " ",
                total_base_imponible: this.asString(
                    (r.total_base_amount !== undefined && r.total_base_amount !== null)
                    ? r.total_base_amount
                    : r.total_base_imponible
                ),
                total_impuestos: this.asString(
                    (r.total_tax_amount !== undefined && r.total_tax_amount !== null)
                    ? r.total_tax_amount    
                    : r.total_impuestos
                ),
                importe_total: this.asString(
                    (r.total_amount !== undefined && r.total_amount !== null)
                    ? r.total_amount
                    : r.importe_total
                ),
                error_to_show:          r.error_to_show || " ",
                error_verifactu:        this.getVerifactuMessage(r.verifactu_status_code, r.verifactu_error_msj),
                cadena_bloques:         r.chain_hash || " ",
            };
        },
        statusLabel(code, msg) {
            if (code === null || code === undefined) return " ";
            if (!msg || String(msg).trim() === "") return "Correcto";
            if (code === 2) return "Correcto";
            if (code === 1) return "Aviso";
            return "Error";
        },
        getVerifactuMessage(code, msg) {
            if (code === null || code === undefined) return " ";
            if (msg) return msg;
            return "Correcto";
        },
        asString(val) {
            return val == null ? " " : String(val);
        },
    },
};
</script>

<style>
.action__btn {
  font-weight: 500; font-size: 14px; line-height: 16px;
  border-radius: 20px; padding: 18px !important; gap: 8px;
  text-transform: capitalize;
}
.primary__blue { color: var(--v-primary_blue-base); }
.config-modal .v-dialog { box-shadow: none !important; background: transparent !important; border-radius: 0 !important; filter: none !important; }
.config-modal { box-shadow: none !important; background: transparent !important; }
</style>

<style scoped>
.config-card { border-radius: 28px !important; overflow: hidden; box-shadow: none !important; }
.head-einvoice-config { background-color: #e4e0ff; color: var(--v-primary_blue-base); }
.v-card__title { padding: 20px 28px; }
.config-body { padding: 16px 28px 0 28px; }
.config-actions { padding: 30px 28px 28px 28px !important; }


.primary-border >>> .v-input__slot fieldset { border-color: var(--v-primary-base) !important; }

.table-row >>> div > .v-input { margin-top: 0; }
.table-row >>> div > .v-input > .v-input__control > .v-input__slot { padding-bottom: 4px; }


.v-input__slot { width: 100% !important; }


::v-deep .primary-border.v-text-field--outlined .v-input__slot > fieldset {
    border-color: var(--v-primary-base) !important;
    border-width: 1px;
}


::v-deep .primary-border.v-text-field--outlined.v-input--is-focused .v-input__slot > fieldset {
    border-color: var(--v-primary-base) !important;
    border-width: 2px;
}

::v-deep .primary-border.v-text-field--outlined > .v-input__control > .v-input__slot {
    box-shadow: 0 6px 3px -2px rgba(0,0,0,.05),
    0 3px 4px  0 rgba(0,0,0,.04),
    0 1px 8px  0 rgba(0,0,0,.03) !important;
    border-radius: 8px;
}


::v-deep .primary-border.v-input--is-focused .v-label,
::v-deep .primary-border.v-input--has-state .v-label,
::v-deep .primary-border .v-label.v-label--active {
    color: var(--v-primary-base) !important;
}

::v-deep .primary-border .v-input__slot { 
    min-height: 56px;
    width: 100%;
}

.contains-input-fields { margin-bottom: 16px; }

/* Aumentar margen izquierdo del label y contenido - con máxima especificidad */
::v-deep .config-card .label-inside.v-text-field .v-input__control .v-label {
  left: -20px !important;
  top: 5px !important;
  margin-bottom: 7px !important;
  transform: none !important;
  position: absolute !important;
}

::v-deep .config-card .label-inside.v-text-field .v-input__control .v-label.v-label--active {
  left: -20px !important;
  top: 5px !important;
  transform: none !important;
  position: absolute !important;
}

::v-deep .config-card .label-inside.v-text-field--outlined .v-input__control .v-label {
  left: -20px !important;
  top: 5px !important;
  transform: none !important;
  position: absolute !important;
}

::v-deep .config-card .label-inside.v-text-field .v-input__control .v-input__slot {
  padding-left: 40px !important;
}

::v-deep .config-card .label-inside.v-text-field .v-input__slot input {
  padding-left: -20px !important;
  margin-left: -20px !important;
  padding-top: 27px !important;
}

::v-deep .config-card .label-inside.v-textarea .v-input__control .v-input__slot {
  padding-left: 40px !important;
}

::v-deep .config-card .label-inside.v-textarea .v-label {
  left: -20px !important;
  top: 5px !important;
  margin-bottom: 7px !important;
  transform: none !important;
  position: absolute !important;
}

::v-deep .config-card .label-inside.v-textarea .v-label.v-label--active {
  left: -20px !important;
  top: 5px !important;
  transform: none !important;
  position: absolute !important;
}

::v-deep .config-card .label-inside.v-textarea .v-input__slot textarea {
  padding-left: -20px !important;
  margin-left: -20px !important;
  padding-top: 17px !important;
}

::v-deep .config-card .roomy-input.v-text-field--outlined > .v-input__control > .v-input__slot {
  padding-left: 40px !important;
  min-height: 56px !important;
  height: 56px !important;
}

::v-deep .config-card .roomy-input.v-textarea > .v-input__control > .v-input__slot {
  padding-left: 40px !important;
  min-height: auto !important;
  height: auto !important;
}


/* @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500&display=swap'); */


::v-deep .config-card {
    font-family: 'Roboto', 'Helvetica Neue', Arial, sans-serif !important;
    color: #56565B; 
}


::v-deep .config-card .v-text-field input,
::v-deep .config-card .v-label,
::v-deep .config-card .v-input__slot,
::v-deep .config-card .v-text-field .v-input__control {
    font-family: inherit !important;
}


::v-deep .config-card .v-text-field input {
    font-size: 16px;
    font-weight: 400;
}
::v-deep .config-card .v-label {
    font-size: 14px;
    font-weight: 500; 
}

::v-deep .roomy-input.v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 50px;             
    padding: 14px 18px 14px var(--field-x) !important;       
    border-radius: 10px;          
}

::v-deep .roomy-input .v-label {
    font-size: 14px;
    font-weight: 600;             
    color: var(--v-primary-base);               
}



::v-deep .roomy-input.v-textarea > .v-input__control > .v-input__slot {
    min-height: 80px;             
    padding: 14px 18px;
}


::v-deep .primary-border.v-text-field--outlined .v-input__slot > fieldset {
    border-color: var(--v-primary-base) !important;
    border-width: 1px;
}
::v-deep .primary-border.v-text-field--outlined.v-input--is-focused .v-input__slot > fieldset {
    border-color: var(--v-primary-base) !important;
    border-width: 2px;
}
:root { --label-gap: 10px; }

::v-deep .roomy-input.v-text-field--outlined.v-input--is-label-active
> .v-input__control > .v-input__slot {
  padding-top: calc(14px + var(--label-gap)) !important; 
}



::v-deep .label-inside .v-label {

  transform: none !important;
  -webkit-transform: none !important;
  top: 1px !important;               /* posición del texto del label dentro de la caja */
             /* margen izquierdo */
  max-width: calc(100% - 32px);       /* que no se salga por la derecha */
  white-space: nowrap;                /* si quieres envolver a 2 líneas, cambia a normal */
  overflow: hidden;
  text-overflow: ellipsis;
}

/* más espacio arriba para el contenido (valor) porque el label ahora vive dentro */
::v-deep .label-inside.v-text-field--outlined > .v-input__control > .v-input__slot {
  padding-top: 34px !important;       /* ajusta 30–36px a tu gusto */
}

/* cerramos la “muesca” del outlined para que no corte el borde */
::v-deep .label-inside.v-text-field--outlined .v-input__slot > fieldset > legend {
  max-width: 0 !important;            /* evita el notch cuando el label está activo */
}

/* ↓ Baja un poco el valor (contenido) de los text-field, sin mover el label */
::v-deep .label-inside .v-input__slot input {
  padding-top: 20px !important;   /* pon 2–6px según lo quieras */
  line-height: 24px;             /* ayuda a que quede más “centrado” */
}

/* ↓ Y lo mismo para los textarea */
::v-deep .label-inside.v-textarea textarea {
  padding-top: 15px !important;   /* ajusta 4–8px si lo ves necesario */
  line-height: 22px;
}

/* cuando el campo está activo/lleno, mantenemos el label dentro (sin escalar) */
::v-deep .label-inside .v-label.v-label--active {
  transform: none !important;
  -webkit-transform: none !important;
}

/* (opcional) si algún tema re-aplica escala al enfocar */
::v-deep .label-inside.v-input--is-focused .v-label {
  transform: none !important;
}

/* === Alinear inicio del label y del contenido === */
/* usa la misma “x” para ambos */
:root { --field-x: 18px; }  /* usa el mismo valor que tu padding izquierdo del slot (roomy-input tiene 18px) */

::v-deep .label-inside .v-label {
  left: var(--field-x) !important;           /* coloca el label */
}

::v-deep .label-inside .v-input__slot {
  padding-left: var(--field-x) !important;   /* mismo inicio para el contenido */
}

/* el input/textarea no debe añadir más padding a la izquierda */
::v-deep .label-inside .v-input__slot input,
::v-deep .label-inside.v-textarea textarea {
  padding-left: 0 !important;
}
/* === SANGRÍA ÚNICA PARA LABEL + CONTENIDO === */
:root { --field-x: 40px; }          /* <- ajustado a 40px para mayor margen izquierdo */

/* 1) EL LABEL se mueve a la derecha la misma cantidad */
::v-deep .label-inside .v-label {
  left: var(--field-x) !important;
}

/* 2) EL CONTENIDO del cam  po empieza en el mismo punto que el label */
::v-deep .label-inside .v-input__slot {
  padding-left: var(--field-x) !important;
}

/* 3) Asegura la misma sangría en text-field y textarea con tu clase roomy-input */
::v-deep .roomy-input.v-text-field--outlined > .v-input__control > .v-input__slot,
::v-deep .roomy-input.v-textarea          > .v-input__control > .v-input__slot {
  padding-left: var(--field-x) !important;
}

/* Si tu input añade padding propio a la izquierda, lo anulamos para no duplicar */
::v-deep .label-inside .v-input__slot input,
::v-deep .label-inside.v-textarea textarea {
  padding-left: 0 !important;
}

</style>
